import { createContext } from 'react'

import { PriceAlign, PriceSize } from './constants'

export type PriceContext = {
  size: PriceSize
  align: PriceAlign
}

export const PriceContext = createContext<PriceContext>({} as PriceContext)
